import { useEffect, useState } from 'react';

/**
 * Debounce a fast-changing value. The returned value updates `delay`
 * milliseconds after the input stops changing — so search inputs can fire
 * one network call per pause instead of one per keystroke.
 *
 * Pair with an Enter-key handler that bypasses the debounce by calling
 * the search directly with the current input value.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
